<template>
  <div
    :class="[$style.containerNoSidebar, $style.container]"
  >
    <PageContainer
      hasWideBreakpoint
    >
      <template v-slot:body>
        <Container>
          <ButtonBack
            text="Users List"
            :to="$options.usersRoute"
          />
        </Container>
        <Card
          :class="$style.cardContainer"
        >
          <SectionUserState
            v-model="orgSettings"
          />
        </Card>
      </template>
      <template v-slot:footer>
        <Container
          :class="$style.footerContainer"
        >
          <ButtonGroupSave
            :isDisabledPrimary="!enableMainAction"
            :isFullWidth="false"
            :isLoadingPrimary="loading"
            :secondaryButtonProps="$options.secondaryButtonProps"
            @primaryAction="handleSave"
            @secondaryAction="handleCancel"
          />
        </Container>
      </template>
    </PageContainer>
    <ModalUndoChanges
      :showModal="showModalUndo"
      @cancel="handleCloseModalUndo"
      @close="handleCloseModalUndo"
      @save="handleContinueUndo"
    />
  </div>
</template>

<script>
import {
  ButtonBack,
  ButtonGroupSave,
  Card,
  Container,
  PageContainer,
} from '@jumpcloud/ui-components';
import ModalUndoChanges from 'client/settings/ModalUndoChanges.vue';
import SectionUserState from 'client/systemusers/SystemUserItemTable/UserManagement/SectionUserState.vue';
import SettingsMixin from 'client/settings/SettingsMixin';

export default {
  name: 'UserManagementPage',

  components: {
    ButtonBack,
    ButtonGroupSave,
    Card,
    Container,
    PageContainer,
    ModalUndoChanges,
    SectionUserState,
  },

  mixins: [SettingsMixin],

  usersRoute: '/users',
};
</script>

<style module>
@import '../../../components/PageLayouts/tabbedPageLayout.css';
@import '../../../settings/settings.css';

.container {
  background-color: var(--jc-color-disabled);
}

.pageContainer {
  padding-top: var(--jc-spacer-medium);
}

.cardContainer {
  --card-background: var(--jc-color-surface-light);

  margin-left: var(--jc-spacer-medium);
  max-width: 100ch;
}

.footerContainer {
  background-color: var(--jc-color-surface-light);
}
</style>
